import { useEffect, useReducer } from "react";
import { Accordion, AccordionSummary, Button, Grid, MenuItem, Paper, TextField, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactQuill from "react-quill";
import { Dropzone, FileMosaic } from "@files-ui/react";


const initialState = {
    name:'',                errorName:false,
    mode:'',                errorMode:false,
    type:'',                errorType: false,
    technology:'',          errorTechnology: false,
    decription:'',          errorDescription: false,
    termsAndConditions:'',  errorTermsAndConditions: false,
    cover: [],
    img:[]
    
}
  
function reducer( state, { field, value })
{
    return{
        ...state,
        [field] : value
    }
}

export default function CashlessEconomyBasicInformation({economy})
{
    const [state,setState] = useReducer(reducer,initialState);
        
    const {
        name, mode, type, technology, description, termsAndConditions,
        errorName, errorMode, errorType, errorTechnology, errorDescription,
        errorTermsAndConditions,
        cover, img
    } = state;

    useEffect(()=>{
        setState({field:"name",value:economy.name});
        setState({field:"mode",value:economy.mode});
        setState({field:"technology",value:economy.technology});
        setState({field:"type",value:economy.type});
        setState({field:"description",value:economy.description});
        setState({field:"termsAndConditions",value:economy.terms_and_conditions});
    },[economy])

    /*const [name,setName] = useState();
    const [mode,setMode] = useState();
    const [type,setType] = useState();*/

    const onChange = (e) => {
        setState({field : e.target.name, value : e.target.value});
    }

    const handleLogoImage = async (incomingFiles) =>
    {
        console.log('incomingFiles ===> ',incomingFiles[0].file);
        setState({field:'cover',value:incomingFiles});
        setState({field:'img',value:incomingFiles[0].file})
    }

    const handleSubmit = async () => {
        //let response = await create(name,mode,type,technology,description,termsAndConditions);
        //console.log(response)
    }


    return(
        <Grid continer spacing={3}>
            <Grid item xxs={12} sm={12} md={12} lg={12} xl={12}>
                <Paper elevation={4}>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <Typography variant="h6">Información Básica</Typography>
                            
                        </Grid>
                        
                        <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                            <Grid container spacing={3}>
                                {/**Name */}
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <TextField
                                        fullWidth
                                        disabled
                                        label='Nombre de la economia'
                                        name='name'
                                        id='name'
                                        required
                                        value={name}
                                        onChange = { onChange }
                                        onBlur={ () => setState({field:'errorName',value:name === ''}) }
                                        error = {errorName}
                                        helperText={errorName && <Typography>Ingrese el nombre de la economia</Typography>}
                                    />
                                </Grid>

                                {/**Mode */}
                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <TextField
                                        fullWidth
                                        disabled
                                        select
                                        id="mode"
                                        name='mode'
                                        label="Modalidad"
                                        variant="outlined"
                                        value = {mode}
                                        onChange = { onChange }
                                        onBlur={ () => setState({field:'errorMode',value:mode === ''}) }
                                        error = {errorMode}
                                        helperText={errorMode && <Typography>Selecciona la modalidad de la economía</Typography>}
                                    >
                                        <MenuItem value=''>Selecciona una modalidad</MenuItem>
                                        <MenuItem value='online'>Online</MenuItem>
                                        <MenuItem value='offline'>Offline</MenuItem>
                                    </TextField>
                                </Grid>

                                {/**Technology */}
                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <TextField
                                        fullWidth
                                        disabled
                                        select
                                        id="technology"
                                        name='technology'
                                        label="Tecnología"
                                        variant="outlined"
                                        value = {technology}
                                        onChange = { onChange }
                                        onBlur={ () => setState({field:'errorTechnology',value:technology === ''}) }
                                        error = {errorTechnology}
                                        helperText={errorType && <Typography>Selecciona la tecnología a utilizar</Typography>}
                                    >
                                        <MenuItem value=''>Selecciona la tecnologia</MenuItem>
                                        <MenuItem value='qr'>QR</MenuItem>
                                        <MenuItem value='nfc'>NFC</MenuItem>
                                    </TextField>
                                </Grid>

                                {/**Type */}
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <TextField
                                        fullWidth
                                        disa
                                        select
                                        id="type"
                                        name='type'
                                        label="Uso de la economía"
                                        variant="outlined"
                                        value = {type}
                                        onChange = { onChange }
                                        onBlur={ () => setState({field:'errorType',value:type === ''}) }
                                        error = {errorType}
                                        helperText={errorType && <Typography>Selecciona para que es la economía</Typography>}
                                    >
                                        <MenuItem value=''>Selecciona el uso de la economía</MenuItem>
                                        <MenuItem value='event'>Evento</MenuItem>
                                        <MenuItem value='club'>Club</MenuItem>
                                        <MenuItem value='community'>Comunidad</MenuItem>
                                        <MenuItem value='business'>Negocio</MenuItem>
                                        <MenuItem value='loyalty_program'>Programa de Lealtad</MenuItem>
                                        <MenuItem value='school'>Escuela</MenuItem>
                                        <MenuItem value='parking'>Estacionamiento</MenuItem>
                                        <MenuItem value='transport'>Transporte</MenuItem>
                                        <MenuItem value='other'>Otro</MenuItem>
                                    </TextField>
                                </Grid>

                                {/**Description */}
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Typography fontWeight={'bold'}>Descripción</Typography>
                                    <Typography fontStyle={'italic'}>Ingresa detalles adicionales de tu economía Cashless</Typography>
                                    <ReactQuill
                                        theme="snow"
                                        placeholder="Describe tu economía cashless en detalle. Incluye información sobre su propósito, cómo funciona, los beneficios para los participantes y cualquier otra característica relevante.."
                                        id="description"
                                        value={description}
                                        onChange={(value)=>setState({field:'description',value:value})}
                                        onBlur={()=>setState({field:'errorDescription',value:description===''?true:false})}
                                        style={{height:300}}
                                    />
                                    {
                                        errorDescription &&
                                        <Typography color={'error.main'}>Ingresa la descripción de la economía</Typography>
                                    }
                                </Grid>

                                {/**Logo */}
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={5}>
                                    <Typography>Logo de la economía</Typography>
                                    <Dropzone
                                        onChange={handleLogoImage}
                                        value={cover}
                                        maxFiles={1}
                                        accept="image/*"
                                    >
                                        {cover.map((file) => (
                                            <FileMosaic key={file.id} {...file} onDelete={()=>{setState({field:'cover',value:[]}); setState({field:'img',value:[]}) }} info preview smartImgFit={"center"}/>
                                            ))}
                                        {
                                            cover.length === 0 &&
                                            <>
                                                <Typography>
                                                    Para el logo de la economía, recomendamos una proporción de 1:1, cuadrada, 512×512 píxeles.
                                                    <br/>PNG, JPG, JPEG hasta 1MB
                                                </Typography>
                                                <Typography variant="body2" color='link.main' fontWeight={'bold'}>
                                                    Arrastra y suelta tu imagen o haz clic para seleccionarla
                                                </Typography>
                                            </>
                                        }
                                    </Dropzone>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display={'flex'} flexDirection={'row'} justifyContent={"flex-end"}>
                                    <Button variant="contained" onClick={()=>handleSubmit()}>
                                        <Typography variant="h6">
                                            Actualizar Economia
                                        </Typography>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    )
}